<template>
  <card
    dis-hover
    class="procedures-item"
    :padding="8"
    @click.native="openProcedure"
  >
    <div class="procedures-item__status">
      <tag class="status" :color="getProcedureStatusColor(status)">
        {{ status }}
      </tag>
      <tag v-if="object === 'expertise'" style="margin-left: 16px;">
        {{ procedure.expertise_type_short_name }}
      </tag>
      <span class="procedures-item__name ms-subhead">
        {{ description || 'Реквизиты отсутствуют' }}
      </span>
    </div>
    <div class="procedures-item__dates">
      <div class="procedures-item__date">
        <span class="ms-help"> Дата создания: </span>
        <tag color="default">
          {{ formatDefaultDate(procedure.create_fact_date) }}
        </tag>
      </div>
      <div class="procedures-item__date">
        <span class="ms-help">
          {{ receiveDateLabel }}
        </span>
        <tag color="default">
          {{ receiveDateValue }}
        </tag>
      </div>
    </div>
  </card>
</template>

<script>
import { getProcedureStatusColor, formatDefaultDate } from '@/utils'

export default {
  props: ['procedure', 'all', 'object'],
  computed: {
    receiveDateLabel () {
      const {
        conclusion_status_name,
        expertise_status_name
      } = this.procedure
      const status = conclusion_status_name || expertise_status_name

      return status === 'Получен'
        ? 'Дата получения:'
        : 'Планируемая дата получения:'
    },
    receiveDateValue () {
      const {
        conclusion_status_name,
        expertise_status_name,
        receive_fact_date,
        receive_plan_date
      } = this.procedure
      const status = conclusion_status_name || expertise_status_name

      return status === 'Получен'
        ? formatDefaultDate(receive_fact_date)
        : formatDefaultDate(receive_plan_date)
    },
    status () {
      return this.procedure[`${this.object}_status_name`]
    },
    description () {
      return this.procedure.description
    }
  },
  methods: {
    openProcedure () {
      if (this.all) this.$store.commit('SET_COME_FROM', 'procedures')

      this.$emit('open-procedure', {
        id: this.procedure.id,
        contract_id: this.procedure.contract_id
      })
    },
    getProcedureStatusColor,
    formatDefaultDate
  }
}
</script>

<style lang="less">
.procedures-item {
  cursor: pointer;
  margin-bottom: 4px;

  &:hover {
    border-color: rgba(@primary-color, 0.6) !important;
  }

  .ivu-card-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .ivu-tag {
    margin: 0;
  }

  &__name {
    flex-shrink: 0;
    min-width: 172px;
  }

  &__status {
    display: flex;
    align-items: center;
    flex-shrink: 0;

    .ms-subhead {
      margin-left: 8px;
    }
  }

  &__dates {
    margin-left: auto;
    display: flex;
    align-items: center;
  }

  &__date {
    flex-shrink: 0;

    .ms-help {
      margin-right: 8px;
    }

    &:not(:first-child) {
      margin-left: 32px;
    }
  }
}
</style>
